export default __webpack_public_path__ + "static/media/flag.9068135f.svg";